import { Controller } from "@hotwired/stimulus"
import SimpleMaskMoney from "simple-mask-money"

// Connects to data-controller="currency"
export default class extends Controller {
  connect() {
    const opts = {
      cursor: 'end'
    }
    SimpleMaskMoney.setMask(this.element, opts);
  }
}
